<div class="mat-table-wrapper wp-70">
    <table
      mat-table
      [dataSource]="dataReportSource"
      aria-describedby="Validate Report Table"
    >
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef class="w-80">S.No.</th>
        <td mat-cell *matCellDef="let element; let i = index">{{ i+1 }}</td>
      </ng-container>
      <ng-container matColumnDef="warning">
        <th mat-header-cell *matHeaderCellDef>message</th>
        <td mat-cell *matCellDef="let element">
            <div class="d-flex">
                <div class="clamp" [title]="element.message">{{ element.message }}</div>
            </div>            
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedReportColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedReportColumns"></tr>
    </table>
</div>